var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _rect5, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 199,
    viewBox: "0 0 116 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.558594,
    y: 100.108,
    width: 20.9573,
    height: 50.2569,
    fill: "#F5F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8926,
    y: 83.0747,
    width: 20.9573,
    height: 67.2897,
    fill: "#F5F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.904 24.8239C75.3214 58.4478 6.6164 79.967 7.68018 78.5397C16.1456 74.347 65.9608 49.8811 92.7304 16.6851L83.9812 9.36024L113.077 0.407593L111.043 31.1314L102.904 24.8239Z",
    fill: "#F5F5F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.2285,
    y: 63.2795,
    width: 20.9573,
    height: 87.0848,
    fill: "#F5F5F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 94.7637,
    y: 43.95,
    width: 20.9573,
    height: 106.414,
    fill: "#F5F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9559 153.293C96.9559 174.419 79.8298 191.545 58.7036 191.545C37.5773 191.545 20.4512 174.419 20.4512 153.293C20.4512 132.166 37.5773 115.04 58.7036 115.04C79.8298 115.04 96.9559 132.166 96.9559 153.293Z",
    fill: "#0E273D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9566 153.293C96.9566 132.332 80.0968 115.308 59.1984 115.043L58.7044 115.04C37.5782 115.04 20.4518 132.167 20.4518 153.293L20.4551 153.787C20.7176 174.521 37.476 191.279 58.21 191.542L58.7044 191.545C79.6655 191.545 96.6887 174.685 96.9533 153.787L96.9566 153.293ZM104.149 153.293C104.148 178.391 83.8025 198.737 58.7044 198.737C33.6062 198.737 13.2599 178.391 13.2598 153.293C13.2598 128.195 33.6062 107.848 58.7044 107.848C83.8026 107.848 104.149 128.195 104.149 153.293Z",
    fill: "#259584"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.3711,
    y: 127.208,
    width: 34.6664,
    height: 50.9538,
    fill: "#F5F5F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3603 142.835C52.9872 142.417 53.7616 142.044 54.655 141.755L54.655 148.631C53.7616 148.342 52.9872 147.969 52.3603 147.551C50.8858 146.568 50.6052 145.654 50.6052 145.193C50.6052 144.732 50.8858 143.818 52.3603 142.835Z",
    fill: "#0E273D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7546 164.83L62.7546 157.954C63.648 158.243 64.4224 158.617 65.0493 159.034C66.5239 160.018 66.8044 160.931 66.8044 161.392C66.8044 161.853 66.5239 162.767 65.0493 163.75C64.4224 164.168 63.648 164.541 62.7546 164.83Z",
    fill: "#0E273D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7048 185.691C76.5978 185.691 91.1029 171.186 91.1029 153.293C91.1029 135.4 76.5978 120.894 58.7048 120.894C40.8118 120.894 26.3066 135.4 26.3066 153.293C26.3066 171.186 40.8118 185.691 58.7048 185.691ZM62.7546 133.044C62.7546 130.807 60.9414 128.994 58.7048 128.994C56.4682 128.994 54.655 130.807 54.655 133.044V133.416C52.1377 133.889 49.8094 134.802 47.8675 136.096C44.9449 138.045 42.5057 141.181 42.5057 145.193C42.5057 149.205 44.9449 152.341 47.8675 154.29C49.8094 155.584 52.1377 156.497 54.6551 156.97L54.6551 164.831C53.0716 164.317 51.8978 163.546 51.2397 162.788C49.7739 161.098 47.2161 160.917 45.5268 162.383C43.8375 163.849 43.6563 166.407 45.1221 168.096C47.4001 170.721 50.8464 172.451 54.655 173.167L54.655 173.541C54.655 175.778 56.4681 177.591 58.7047 177.591C60.9413 177.591 62.7545 175.778 62.7546 173.541L62.7546 173.169C65.2719 172.696 67.6003 171.784 69.5421 170.489C72.4648 168.541 74.9039 165.404 74.9039 161.392C74.9039 157.38 72.4647 154.244 69.5421 152.295C67.6002 151.001 65.2719 150.088 62.7546 149.615L62.7546 141.754C64.338 142.268 65.5118 143.039 66.1699 143.797C67.6358 145.487 70.1935 145.668 71.8829 144.202C73.5722 142.736 73.7534 140.178 72.2875 138.489C70.0096 135.864 66.5632 134.134 62.7546 133.418V133.044Z",
    fill: "#0E273D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9981d71774e7eee7d3eda367b3ac671e.svg";
export { ForwardRef as ReactComponent };